import { TbPolygon } from "react-icons/tb";

import i18n from "@/app/i18n";
import {
  CircleFilledIcon,
  CubeIcon,
  HelpIcon,
  ImageIcon,
  OutlineTextFieldsIcon,
  PositionIcon,
  RouteIcon,
} from "@/features/app/components/icons";
import { OverlayFeatureTypes } from "@/features/editor/types";

type AcceptedFeatureTypes = OverlayFeatureTypes | "link" | "node";

export const getColorFromFeatureType = (featureType: AcceptedFeatureTypes) => {
  switch (featureType) {
    case OverlayFeatureTypes.model:
      return "#00a2ff";
    case OverlayFeatureTypes.icon:
      return "#ad56d9";
    case OverlayFeatureTypes.text:
      return "#00aa19";
    case OverlayFeatureTypes.poi:
      return "#f46f6f";
    case OverlayFeatureTypes.geofence:
      return "#ffa81b";
    case "link":
    case "node":
      return "#ee0093";
    default:
      return "#000000";
  }
};

export const getTextFromFeatureType = (featureType: AcceptedFeatureTypes) => {
  switch (featureType) {
    case OverlayFeatureTypes.model:
      return i18n.t("models.3d_model", { ns: "editor" });
    case OverlayFeatureTypes.icon:
      return i18n.t("models.icon", { ns: "editor" });
    case OverlayFeatureTypes.text:
      return i18n.t("models.text", { ns: "editor" });
    case OverlayFeatureTypes.poi:
      return i18n.t("models.poi", { ns: "editor" });
    case OverlayFeatureTypes.geofence:
      return i18n.t("models.geofence", { ns: "editor" });
    case "link":
      return i18n.t("models.path_link", { ns: "editor" });
    case "node":
      return i18n.t("models.path_node", { ns: "editor" });
    default:
      return featureType;
  }
};

export const getIconFromFeatureType = (
  featureType: AcceptedFeatureTypes,
  useFeatureTypeColor?: boolean,
) => {
  switch (featureType) {
    case OverlayFeatureTypes.model:
      return (
        <CubeIcon
          color={
            useFeatureTypeColor
              ? getColorFromFeatureType(featureType)
              : undefined
          }
        />
      );
    case OverlayFeatureTypes.icon:
      return (
        <ImageIcon
          color={
            useFeatureTypeColor
              ? getColorFromFeatureType(featureType)
              : undefined
          }
        />
      );
    case OverlayFeatureTypes.text:
      return (
        <OutlineTextFieldsIcon
          color={
            useFeatureTypeColor
              ? getColorFromFeatureType(featureType)
              : undefined
          }
        />
      );
    case OverlayFeatureTypes.poi:
      return (
        <PositionIcon
          color={
            useFeatureTypeColor
              ? getColorFromFeatureType(featureType)
              : undefined
          }
        />
      );
    case OverlayFeatureTypes.geofence:
      return (
        <TbPolygon
          color={
            useFeatureTypeColor
              ? getColorFromFeatureType(featureType)
              : undefined
          }
        />
      );
    case "node":
      return (
        <CircleFilledIcon
          color={
            useFeatureTypeColor
              ? getColorFromFeatureType(featureType)
              : undefined
          }
        />
      );
    case "link":
      return (
        <RouteIcon
          color={
            useFeatureTypeColor
              ? getColorFromFeatureType(featureType)
              : undefined
          }
        />
      );
    default:
      return (
        <HelpIcon
          color={
            useFeatureTypeColor
              ? getColorFromFeatureType(featureType)
              : undefined
          }
        />
      );
  }
};
